// extracted by mini-css-extract-plugin
module.exports = {"ooka-for-business":"Ooka_for_business_ooka-for-business__CGoev"};